<template>
  <div>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800"
        v-model="ordersNotShippedDialog"
    >
      <v-card>
        <v-toolbar
            color="primary"
            dark
        >
          <h3>Pedidos com a data de envio em atraso (prazo máximo para envio é 2 dias úteis)</h3>
        </v-toolbar>
        <v-card-text >
          <v-card
              v-for="(order, index) in ordersNotShipped"
              :key="`${order.id}_${index}`"
              class="mb-3 ma-0 orders pa-0"
              elevation="2"
          >
            <v-card-title class=" ma-0   pa-3" >
              <div class="d-flex justify-space-between">
                <p class="title-card"><strong>Pedido:</strong> {{order.orderCode}}</p>
                <p class="title-card"><strong>Data da compra:</strong> {{formatDate(order.created_at)}}</p>
              </div>
              <v-divider></v-divider>

              <div class="d-flex justify-space-between">
                <p class="title-card"><strong>Cliente: </strong> {{order.client.name}}</p>
                <p class="title-card"><strong>E-mail do cliente: </strong> {{order.client.email}}</p>
              </div>

              <v-divider></v-divider>

              <div class="d-flex justify-space-between">
                <p class="title-card"><strong>Revenda:</strong> {{order.resale.nameFantasy}}</p>
                <p class="title-card"><strong>E-mail da revenda:</strong> {{order.resale.email}}</p>
              </div>
              <v-divider></v-divider>
              <div class="mt-2">
                <h4 class="text-left">Itens comprados</h4>
                <table class="table-itens mt-2" style="width: 100%">
                  <thead>
                  <tr class="thead-itens">
                    <th class="thead-th-itens">SKU</th>
                    <th class="thead-th-itens">Produto</th>
                    <th class="thead-th-itens">Qtd</th>
                    <th class="thead-th-itens">Total</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr
                      v-for="item in order.items"
                      :key="`${order.id}_${item.id}_${index}`"
                  >
                    <td class="td-itens">{{ item.productSku.attributes[0].name }}</td>
                    <td class="td-itens">{{ item.productSku.product.productName }}</td>
                    <td class="td-itens">{{ item.qty }}</td>
                    <td class="td-itens">{{
                        (item.qty * item.price).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-flex justify-space-between mt-5">
                <h5>Valor total do pedido</h5>
                <h5>{{
                    (order.fretePrice + order.totalPrice + order.installmentsInterest).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}</h5>
              </div>
            </v-card-title>

            <v-card-actions class="ml-9 mt-0" style="margin-top: -10px">
              <v-btn icon @click="goToOrder(order)">
                <strong class="mr-1" style="color: #bc0000">Ver pedido</strong>
                <v-icon color="#bc0000" size="25">mdi-chevron-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-app-bar v-if="!isMobile" app flat color="#eee" absolute height="82">
      <v-spacer />

      <v-badge
          v-if="user && user.type !== userTypeInstaller && ordersNotShipped && ordersNotShipped.length > 0"
          :content="ordersNotShipped.length"
          color="#bc0000"
          :value="ordersNotShipped.length"
          overlap
          class="mr-3"
          style="margin-bottom: -5px;"
      >
        <v-icon
            size="35"
            style="margin-top: -5px; margin-right: -5px!important; cursor: pointer"
            @click="ordersNotShippedDialog = true"
        >
          mdi-bell
        </v-icon>
      </v-badge>


      <Avatar :user="user" />
    </v-app-bar>

    <!-- Lateral Bar -->
    <v-navigation-drawer
      v-if="!isMobile"
      color="#000000"
      app
      permanent
      height="100%"
      width="15.75%"
      :mini-variant.sync="mini"
      mini-variant-width="150"
    >
      <v-list-item link>
        <v-list-item-content class="d-flex align-center justify-center pa-0">
          <v-img
            v-if="mini ? false : true"
            src="../../assets/logo-imprimax2.svg"
            max-width="80%"
            alt="IMPRIMAX-logo"
            contain
            style="padding: 10%"
          ></v-img>

          <v-img
            v-if="mini ? true : false"
            src="../../assets/logo-imprimax-mini.svg"
            max-width="10"
            alt="IMPRIMAX-logo"
            contain
          ></v-img>
        </v-list-item-content>
      </v-list-item>

      <v-list nav dense class="d-flex-column align-center justify-center pa-3">
        <v-list-group
          v-for="header in headers"
          :key="header.title"
          @click="goTo(header.url)"
          v-show="hasAccess(header.access)"
        >
          <template :href="header.url" v-slot:activator>
            <v-list-item-content
              class="nav-icon white--text"
              style="text-align-last: center"
            >
              <v-icon small :class="header.class" color="white">{{
                header.icon
              }}</v-icon>
              <v-list-item-title
                class="title-menu pb-1"
                style="font-weight: bold"
                v-text="header.title"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="([subtitle, suburl], i) in header.items"
            :href="suburl"
            :key="i"
            link
          >
            <v-list-item-title
              class="title-menu white--text"
              style="text-align: left; padding-left: 30px"
              v-text="subtitle"
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Mobile Bar-->
    <v-app-bar v-if="isMobile" app flat color="#000000">
      <v-app-bar-nav-icon
        color="#FFFFFF"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
      <v-spacer />
      <v-img
        max-width="110"
        src="../../assets/logo-imprimax2.svg"
        alt="IMPRIMAX"
        contain
      ></v-img>

      <v-spacer />
      <v-badge
          v-if="user && user.type !== userTypeInstaller && ordersNotShipped && ordersNotShipped.length > 0"
          :content="ordersNotShipped.length"
          color="#bc0000"
          :value="ordersNotShipped.length"
          overlap
          class="mr-3"
          style="margin-bottom: -10px;"
      >
        <v-icon
            color="#bc0000"
            size="35"
            style="margin-top: -5px; margin-right: -5px!important; cursor: pointer"
            @click="ordersNotShippedDialog = true"
        >
          mdi-bell
        </v-icon>
      </v-badge>
      <Avatar :user="user" />
    </v-app-bar>

    <v-navigation-drawer
      v-if="isMobile && drawer"
      v-model="drawer"
      color="#000000"
      app
      temporary
      height="100%"
      :mini-variant.sync="mini"
      width="150"
      mini-variant-width="100"
    >
      <v-list-item link>
        <v-list-item-content class="d-flex align-center justify-center">
          <v-img
            v-if="mini ? false : true"
            src="../../assets/logo-imprimax2.svg"
            max-width="120"
            alt="IMPRIMAX-logo"
            contain
          ></v-img>

          <v-img
            v-if="mini ? true : false"
            src="../../assets/logo-imprimax-mini.svg"
            max-width="14"
            alt="IMPRIMAX-logo"
            contain
          ></v-img>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        v-for="header in headers"
        :key="header.title"
        @click="goTo(header.url)"
        v-show="hasAccess(header.access)"
      >
        <template :href="header.url" v-slot:activator>
          <v-list-item-content
            class="nav-icon white--text"
            style="text-align-last: center"
          >
            <v-icon :class="header.class" color="white">{{
              header.icon
            }}</v-icon>
            <v-list-item-title v-text="header.title"></v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="([subtitle, suburl], i) in header.items"
          :href="suburl"
          :key="i"
          link
        >
          <v-list-item-title
            class="white--text"
            style="text-align-last: end"
            v-text="subtitle"
          ></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-navigation-drawer>
  </div>
</template>

<style>
.v-list-item__icon {
  display: none !important;
}
html {
  overflow: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: #faf9f9;
}

.v-list-item__icon {
  display: none !important ;
  text-decoration: none !important ;
}

.v-navigation-drawer--mini-variant,
.v-navigation-drawer {
  overflow: auto !important;
}

i.v-icon.notranslate.mdi.mdi-teach.theme--light.white--text.AplicadoresIcon {
  font-size: larger;
}

.v-navigation-drawer__content {
  overflow: visible !important;
}

.v-navigation-drawer__border {
  overflow: auto !important;
}

.v-toolbar__title {
  /* font-family: Poppins; */
  font-size: 1.8rem !important;
}

.title-menu {
  border-bottom: 3px solid transparent;
  padding: 0 15px;
}
.title-menu-list {
}
.title-menu-list:hover {
  font-weight: bold !important;
}

.v-list-group {
  -webkit-box-pack: center;
  justify-content: center;
  border-bottom: 3px solid transparent;
}

.menu-lateral {
  color: white !important;
}

.title-menu:hover {
  border-bottom: 3px solid white;
  /* background: red; */
}
.orders{

}
.title-card{
  text-align: left;
  font-size: 14px;
}
.table-itens {
  color: rgba(0, 0, 0, 0.6);
  border: 1px solid #6D7989;
  vertical-align:middle;
  border-collapse:collapse
}
.thead-itens, .thead-th-itens{
  font-size: 15px;
  border: 1px solid #6D7989;
}
.td-itens{
  font-size: 14px;
  border: 1px solid #6D7989;
}
</style>

<script>
import Avatar from "../Internal/Avatar.vue";
import ApiService from "../../services/ApiService";
import Utils from "../../Utils/FormatDate";

export default {
  name: "Navigation",

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  async mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    await this.listOrdersNotShipped()
    if (localStorage.getItem("modalOrders") == 'true' && this.ordersNotShipped && this.ordersNotShipped.length > 0) {
      this.ordersNotShippedDialog = true
      localStorage.setItem("modalOrders", null);
    }
  },

  data: () => ({
    userTypeResale: 2,
    userTypeInstaller: 3,
    isMobile: false,
    ordersNotShipped: [],
    ordersNotShippedDialog: false,
    apiService: new ApiService(),
    drawer: false,
    group: null,
    // mini: true, if initial mini navigation
    mini: false,
    user: {},
    headers: [
      {
        icon: "mdi-finance",
        title: "Dashboard",
        url: "/dashboard",
        access: [0, 1, 5, 6, 7],
      },
      {
        icon: "mdi-finance",
        title: "Vendas",
        url: "/vendas",
        access: [0, 1, 5, 6, 7],
      },
      {
        icon: "mdi-finance",
        title: "Cursos",
        url: "/cursos",
        access: [0, 1, 5, 6, 7, 8],
      },
      {
        icon: "mdi-finance",
        title: "Feed de noticias",
        url: "/feed-noticias",
        access: [2],
      },
      {
        icon: "mdi-finance",
        title: "Painel",
        url: "/dash-resale",
        access: [2],
      },
      {
        icon: "mdi-account-circle",
        title: "Usuários",
        items: [["Usuários", "users"]],
        url: "/users",
        access: [0, 1],
      },
      {
        icon: "mdi-bullhorn-outline",
        title: "Marketing",
        url: "/marketing",
        items: [["Cadastrar Banners", "add-banner"]],
        access: [0, 1, 6],
      },
      {
        icon: "mdi-bullhorn-outline",
        title: "Notícias",
        url: "/noticias",
        items: [["Cadastrar notícias", "cadastrar-noticia"]],
        access: [0, 1, 6],
      },
      {
        icon: "mdi-package-variant",
        title: "Produtos",
        items: [
          ["Produtos", "products"],
          ["Cadastrar", "add-product"],
          ["Configurações", "products-config"],
          ["Cupons", "coupons"],
        ],
        url: "/products",
        access: [0, 1, 6],
      },
      {
        icon: "mdi-history",
        title: "Logs",
        url: "/logs",
        access: [0, 1, 6],
      },
      {
        icon: "mdi-chat-question-outline",
        title: "Perguntas Frequentes",
        url: "/perguntasFrequentesAdmin",
        access: [0, 1, 6],
      },
      {
        icon: "mdi-package",
        title: "Estoque de revendas",
        url: "/resale-stock",
        access: [0, 1],
      },
      {
        icon: "mdi-package",
        title: "Central de promoções",
        url: "/promotions-center",
        access: [0, 1],
      },
      {
        icon: "mdi-file-document-multiple",
        title: "Pedidos",
        url: "/orders",
        access: [0, 1],
      },
      {
        icon: "mdi-file-document-multiple",
        title: "Meus Pedidos",
        items: [["Pedidos", "orders-resale"]],
        url: "/orders-resale",
        access: [2],
      },
      {
        icon: "mdi-file-document-multiple",
        title: "Promoções",
        items: [],
        url: "/promotions-center-resale",
        access: [2],
      },
      {
        icon: "mdi-finance",
        title: "Financeiro",
        items: [
          ["Pagamentos", "financial-payments"],
          ["Transferências", "financial-receivables"],
          ["Saques", "financial-withdrawal"],
        ],
        url: "",
        access: [2],
      },
      {
        icon: "mdi-finance",
        title: "Financeiro",
        items: [
          ["Transações", "financeiro-transacoes"],
        ],
        url: "",
        access: [5],
      },
      {
        icon: "mdi-package-variant",
        title: "Meus Produtos",
        items: [
          ["Produtos", "product-resale"],
          ["Adicionar", "product-select"],
        ],
        url: "/product-resale",
        access: [2],
      },
      {
        icon: "mdi-room-service",
        title: "Meus Serviços",
        items: [["Serviços", "installers-service"]],
        url: "",
        access: [3],
      },
      {
        icon: "mdi-account-group",
        title: "Revendedores",
        items: [
          ["Revendas", "resales"],
          ["Cadastrar", "add-resales"],
        ],
        url: "/resales",
        access: [0, 1, 7],
      },
      {
        icon: "mdi-account-hard-hat",
        class: "AplicadoresIcon",
        title: "Aplicadores",
        items: [
          ["Aplicadores", "installers"],
          ["Cadastrar", "add-installer"],
          ["Configurações", "installers-config"],
        ],
        url: "/installers",
        access: [0, 1, 8],
      },

      {
        icon: "mdi-account-group",
        title: "Clientes",
        url: "/clients",
        access: [0, 1, 6],
      },
      // RasaleView
      {
        icon: "mdi-cog",
        title: "Configurações",
        url: "/userconfig",
        access: [0, 1, 2, 3, 5, 6, 7, 8],
      },
      // // Installer
      // {
      //   icon: "mdi-cog",
      //   title: "ConfiguraçõesInstaller",
      //   url: "/resaleconfig",
      //   access: [3],
      // },
      // // Master e Admin
      // {
      //   icon: "mdi-cog",
      //   title: "ConfiguraçõesAdmin",
      //   url: "/resaleconfig",
      //   access: [0,1],
      // },
    ],
  }),

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  components: {
    Avatar,
  },

  methods: {
    async goToOrder(item) {
      const route = this.user && this.user.type === this.userTypeResale ? `order-detailresale`: 'order-detail'
      this.ordersNotShippedDialog = false
      await this.$router.push({
        path: `/${route}?id=${item.id}`,
        params: item,
      });
      location.reload();
    },

    hasAccess(val) {
      const result = val.find((type) => this.user.type === type);

      if (result === undefined) {
        return false;
      } else {
        return true;
      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 960;
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    async listOrdersNotShipped() {
      try {
        const filter = {
          resaleId: this.user && this.user.type === this.userTypeResale ? this.user.id: null
        }
        this.ordersNotShipped = await this.apiService.post("order/not-shipped/", filter, false, false, false)
      } catch (e) {
      }
    },

    async goTo(path, config) {
      if (path !== this.$route.path && path !== "" && config !== "true") {
        await this.$router.push(path);
      }

      if (path !== this.$route.path && path !== "" && config == "true") {
        await this.$router.push({
          path: `/resaleconfig?id=` + item.id + `&profile=` + item.name,
          params: item,
        });
      }
    },
  },
};
</script>
